import { effect, inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { I18nService } from './i18n';

const TEXT = {
  mk: { per: 'По страна:', of: 'од', next: 'Следна', prev: 'Претходна', first: 'Прва', last: 'Последна' },
  en: { per: 'Per page:', of: 'of', next: 'Next', prev: 'Previous', first: 'First', last: 'Last' },
  sq: { per: 'Për faqe:', of: 'nga', next: 'Tjetra', prev: 'E mëparshmja', first: 'E para', last: 'E fundit' },
};

@Injectable()
export class LocalizedPaginatorIntl extends MatPaginatorIntl {
  private readonly i18n = inject(I18nService);

  constructor() {
    super();
    effect(() => {
      const t = TEXT[this.i18n.lang()];
      this.itemsPerPageLabel = t.per;
      this.nextPageLabel = t.next;
      this.previousPageLabel = t.prev;
      this.firstPageLabel = t.first;
      this.lastPageLabel = t.last;
      this.getRangeLabel = (page, size, length) => {
        if (length === 0) return `0 ${t.of} 0`;
        const start = page * size;
        return `${start + 1}–${Math.min(start + size, length)} ${t.of} ${length}`;
      };
      this.changes.next();
    });
  }
}
